import React from "react";
import { useTranslation } from "react-i18next";

import { isNullOrWhitespace } from "@utils/utility";
import { getSystemString } from "@utils/account-statement/AccountStatementUtils";
import { AccStatementBetSlipEventInOffer } from "@data-types/account-statement/AccountStatementBetSlip";

export function AdditionalDescriptionSystem(props: {
	slipDetails: AccStatementBetSlipEventInOffer;
}) {
	const t = useTranslation().t;

	if (
		!("system" in props.slipDetails!) ||
		isNullOrWhitespace(props.slipDetails.system)
	) {
		return <></>;
	}
	const {
		system,
		combinationBettingOffersBankCount,
		eventCount,
		combinationBettingOffersCount,
	} = props.slipDetails;

	const systemString = getSystemString({
		system,
		combinationBettingOffersBankCount,
		eventCount,
		combinationBettingOffersCount,
	});

	return (
		<>
			{t<string>("ACC_STATEMENT.BET_DETAILS.INFO_SYSTEM", {
				interpolation: { escapeValue: false },
				0: systemString,
			})}
		</>
	);
}
